module.exports = __webpack_public_path__ + "static/img/5627.821c0c49.png";